import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'

import { useMediaQuery } from 'src/lib/use-media-query'
import styles from 'src/styles/common.module.scss'

export const TextHeaderDe = () => {
    const isMobile = useMediaQuery('(max-width: 540px)')

    return (
        <HighlightedText
            text="HOLEN SIE SICH IHREN BONUS"
            highlights={[{ word: 'IHREN BONUS' }]}
            breakAfterWords={isMobile ? ['SICH'] : []}
            className={styles.text_header}
        />
    )
}

export const TextContentDe = () => {
    return (
        <HighlightedText
            text="325% Einzahlungsbonus + 400 FREISPIELE"
            highlights={[{ word: '325%' }, { word: '+ 400' }]}
            breakAfterWords={['325%', 'Einzahlungsbonus']}
            className={styles['text_content--FOURTH']}
        />
    )
}
